import Cookies from 'js-cookie'

const TokenKey = 'user'

export function getToken() {
    // let user = JSON.parse(Cookies.get(TokenKey));
    if(Cookies.get(TokenKey)==undefined){
        return undefined;
    }
    let userStatus = JSON.parse(Cookies.get(TokenKey));
    return userStatus;
}

export function setToken(user) {
    let userStatus = JSON.stringify(user);
    return Cookies.set(TokenKey, userStatus)
}

export function removeToken() {
    return Cookies.remove(TokenKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js